/**
 * Template: Page - Museum
 * ------------------------------------------------------------------------------
 */
import {load} from '@shopify/theme-sections';
import '../sections/page-museum';

document.addEventListener('DOMContentLoaded', () => {
  load('page-museum');
});
